import Entity from "@/services/westore/entities/entity";


class User extends Entity {
    static auth = '/auth/user';
    static auth_update = '/update-user'

    static info() {
        return super.get(User.auth)
    }

    static update(data) {
        return super.post({uri: User.auth_update, payload: data})
    }
}

export default User;